// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SMnq","newExpiryDate":"styles_newExpiryDate__3TvYm","footer":"styles_footer__3nYFy"};